import { Component, Output, EventEmitter, Input, ViewChild, OnChanges, SimpleChanges } from '@angular/core';

import { InfluencerPost } from '../../../../../models/influencer';
import { PostListComponent } from '../../post-list/post-list.component';

@Component({
    selector: 'influencer-posts',
    templateUrl: './influencer-posts.component.html',
    styleUrls: ['./influencer-posts.component.scss']
})
export class InfluencerPostsComponent implements OnChanges {
    public hasNoData = false;

    @Input() postList: Array<InfluencerPost>;
    @Input() influencerGroupId: number;
    @Input() imageReady: boolean;
    @Input() isFetchingData: boolean;

    @Output()
    public openIncompleteStory: EventEmitter<any> = new EventEmitter<any>();

    @ViewChild('PostList')
    public mansoryPostListContainer: PostListComponent;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.postList) {
            const currentPostList = changes.postList.currentValue;
            this.hasNoData = !Array.isArray(currentPostList) || currentPostList.length === 0;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-overview/influencer-posts/influencer-posts.component.ts